
import dayjs from 'dayjs'//时间处理器
import utc from 'dayjs/plugin/utc'// dependent on utc plugin
import timezone from 'dayjs/plugin/timezone'
// dayjs多时区
dayjs.extend(utc)
dayjs.extend(timezone)
export default dayjs